import React, { Component } from 'react'
import { Route, NavLink } from 'react-router-dom'
import { translate } from 'react-i18next'
import { compose } from 'react-apollo'

import DetailsForm from './DetailsForm'
import DescriptionForm from './DescriptionForm'
import LanguagesForm from './LanguagesForm'
import LocationForm from './LocationForm'
import CategoryForm from './CategoryForm'
import PhotosForm from './PhotosForm'
import FinishPage from './FinishPage'

class ActivityGuideProfile extends Component {
  constructor() {
    super()
    this.state = {
      routes: {}
    }
  }

  validateViewForm = (route, valid) => {
    this.setState({
      routes: Object.assign({}, this.state.routes, { [route]: valid })
    })
  }

  routeValid = n => {
    return this.state.routes[n]
  }

  componentWillReceiveProps(nextProps) {
    if (!this.props.user && !nextProps.loading && !nextProps.user) {
      this.props.redirect()
    }
  }

  getNavSteps = () => {
    const { t } = this.props

    return [
      {
        title: t('details'),
        route: 'details'
      },
      {
        title: t('description'),
        route: 'description'
      },
      {
        title: t('location'),
        route: 'location'
      },
      {
        title: t('photos'),
        route: 'photos'
      },
      {
        title: t('languages'),
        route: 'languages'
      },
      {
        title: t('category'),
        route: 'category'
      }
    ]
  }

  componentDidMount() {
    this.props.history.push('/activity-guide-profile/details')
  }

  getStepNumber = () => {
    const pathElements = this.props.location.pathname.split('/')
    const route = pathElements[pathElements.length - 1]
    return this.getNavSteps().findIndex(step => step.route === route)
  }

  render() {
    const { t } = this.props
    return (
      <div className="steps-screen">
        <div className="steps-screen__left-bar">
          <img src="/img/logo-white.svg" className="steps-screen__left-bar-logo" alt="Trippere logo" />
          <div className="steps-screen__left-bar-nav">
            <h2 className="steps-screen__left-bar-section">{t('main_info')}</h2>
            {this.getNavSteps().map((step, index) => {
              const stepNumber = this.getStepNumber()
              return (
                <div key={step.route}>
                  {step.subtitle && <h2 className="steps-screen__left-bar-section">{step.subtitle}</h2>}
                  <NavLink to={`/activity-guide-profile/${step.route}`} className="steps-screen__left-bar-link" activeClassName="active">
                    {step.title}
                    {this.routeValid(index) && <span>&#10003;</span>}
                  </NavLink>
                </div>
              )
            })}
            <h2 className="steps-screen__left-bar-section">
              <NavLink to={`/activity-guide-profile/finish`} className="steps-screen__left-bar-subtitle">
                {t('finish')}
              </NavLink>
            </h2>
          </div>
        </div>
        <div className="steps-screen__right-container">
          <div className="steps-screen__top-bar">
            <img src="/img/logo-blue.svg" className="steps-screen__top-bar-logo" alt="Trippere logo" />
          </div>
          <Route path="/activity-guide-profile/details" render={() => <DetailsForm {...this.props} validate={this.validateViewForm} />} />
          <Route
            path="/activity-guide-profile/description"
            render={() => <DescriptionForm {...this.props} validate={this.validateViewForm} />}
          />
          <Route path="/activity-guide-profile/location" render={() => <LocationForm {...this.props} validate={this.validateViewForm} />} />
          <Route
            path="/activity-guide-profile/languages"
            render={() => <LanguagesForm {...this.props} validate={this.validateViewForm} />}
          />
          <Route path="/activity-guide-profile/category" render={() => <CategoryForm {...this.props} validate={this.validateViewForm} />} />
          <Route path="/activity-guide-profile/photos" render={() => <PhotosForm {...this.props} validate={this.validateViewForm} />} />
          <Route path="/activity-guide-profile/finish" render={() => <FinishPage {...this.props} />} />
        </div>
      </div>
    )
  }
}

const enhance = compose(translate('guide'))

export default enhance(ActivityGuideProfile)



// WEBPACK FOOTER //
// src/components/Guide/ActivityGuideProfile.jsx